<template>
  <v-container fluid>
    <v-row v-if="!forGroup">
      <v-col>
        <template-departure-date-select
          v-model="selectedDepartureDate"
          :departures="departures"
          :outlined="outlinedInputs"
        ></template-departure-date-select>
      </v-col>
    </v-row>
    <v-expansion-panels
      multiple
      v-model="panels"
      v-if="(selectedDepartureDate && extraTypes) || (forGroup && extraTypes)"
    >
      <template-slab
        v-for="slab in slabs"
        :key="slab.id"
        :slab="slab"
        :services="templateItems"
        :headers="headers"
        :departure-date="selectedDepartureDate"
        :department="department"
        :destination="destination"
        :duration="duration"
        :extra-types="extraTypes ? extraTypes.edges : []"
        @change="onChange"
        @remove="onRemove"
        :for-group="forGroup"
      ></template-slab>
    </v-expansion-panels>
    <v-row>
      <add-btn
        label="Add Slab"
        icon="mdi-ballot"
        @click="onAddSlab"
        :disabled="selectedDepartureDate == '' && !forGroup"
      ></add-btn>
    </v-row>
    <v-row v-if="debug">
      <v-col>
        <code>slabs: {{ slabs }}</code>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AddBtn from "../../shared/AddBtn";
import TemplateDepartureDateSelect from "./TemplateDepartureDateSelect";
import TemplateSlab from "./TemplateSlab";
import { ALL_EXTRA_SERVICE_TYPES_SEARCH_QUERY } from "../../../../constants/graphql";

const randomize = require("randomatic");
const moment = require("moment");
export default {
  name: "template-slabs",

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    templateItems: {
      type: Array,
      default: () => [],
    },
    templateId: {
      type: String,
      default: () => "",
    },
    departures: {
      type: Array,
      default: () => [],
    },
    department: {
      type: String,
      default: () => "FIT",
    },
    destination: {
      type: String,
      default: () => "",
    },
    duration: {
      type: Number,
      default: () => 0,
    },
    forGroup: {
      type: Boolean,
      default: () => false,
    },
  },

  components: {
    AddBtn,
    TemplateDepartureDateSelect,
    TemplateSlab,
  },

  data() {
    return {
      debug: false,
      slabs: this.value ? [...this.value] : [],
      panels: [],
      selectedDepartureDate: this.forGroup ? moment().format("YYYY-MM-DD") : "",
      headers: [
        {
          text: "Supplier",
          value: "supplierName",
          name: "supplierName",
          sortable: false,
          editable: false,
        },
        {
          text: "Service",
          value: "serviceName",
          name: "serviceName",
          sortable: false,
          editable: false,
        },
        {
          text: "Rate Type",
          value: "rateType",
          name: "rateType",
          sortable: false,
          editable: false,
        },

        {
          text: "Supplier Comp",
          value: "supplierComp",
          name: "supplierComp",
          sortable: false,
          editable: false,
        },
        {
          text: "Pass Comp",
          value: "passComp",
          name: "passComp",
          sortable: false,
          editable: false,
        },

        {
          text: "Duration",
          value: "duration",
          name: "duration",
          sortable: false,
          editable: false,
        },
        {
          text: "PP Price",
          value: "ppPrice",
          name: "ppPrice",
          sortable: false,
          editable: false,
        },
        {
          text: "Total",
          value: "total",
          name: "total",
          sortable: false,
          editable: false,
        },
      ],
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newSlabs) {
      this.slabs = [...newSlabs];
    },
  },

  methods: {
    onAddSlab() {
      const slabNo = this.slabs.length + 1;
      const paxFrom =
        this.slabs.length == 0 ? 2 : this.slabs[this.slabs.length - 1].paxFrom;
      this.panels.push(this.slabs.length);
      // console.log(paxFrom);
      //const paxFrom = 2;
      this.slabs.push({
        id: randomize("Aa0", 32),
        name: `Slab ${slabNo}`,
        paxFrom,
        foc: 0,
        description: "",
        items: this.templateItems.reduce(
          (servicesAndExtras, templateServiceItem) => {
            const qty =
              templateServiceItem.serviceType == "ACCOMMODATION"
                ? Math.ceil(
                    parseInt(paxFrom) /
                      parseInt(templateServiceItem.stdOccupancy)
                  )
                : templateServiceItem.maxOccupancy
                ? Math.ceil(
                    parseInt(paxFrom) /
                      parseInt(templateServiceItem.maxOccupancy)
                  )
                : 1;
            const adults =
              this.forGroup &&
              templateServiceItem.serviceType == "ACCOMMODATION"
                ? templateServiceItem.stdOccupancy
                : Number(paxFrom);
            const children = 0;
            const infants = 0;
            servicesAndExtras.push({
              id: randomize("Aa0", 32),
              templateItemUid: templateServiceItem.uid,
              adults,
              children,
              infants,
              qty,
              supplierComp: 0,
              passComp: 0,
              foc: 0,
            });
            if (templateServiceItem.extras) {
              for (const extra of templateServiceItem.extras) {
                const extraType = this.extraTypes.edges.find(
                  (e) => e.node.id == extra.extraId
                );
                let extraQty = 1;
                if (extraType) {
                  if (extraType.node.isChildOnly) {
                    extraQty = children;
                  } else if (extraType.node.isInfantOnly) {
                    extraQty = infants;
                  } else {
                    extraQty = adults; // + item.children + item.infants;
                  }
                }
                servicesAndExtras.push({
                  id: randomize("Aa0", 32),
                  templateItemUid: `${templateServiceItem.uid}_${extra.extraId}`,
                  adults: 0,
                  children: 0,
                  infants: 0,
                  qty: extraQty,
                  supplierComp: 0,
                  passComp: 0,
                  foc: 0,
                });
              }
            }
            return servicesAndExtras;
          },
          []
        ),
      });
      this.$emit("input", [...this.slabs]);
    },
    onChange(payload) {
      const editedIndex = this.slabs.map((s) => s.id).indexOf(payload.id);
      if (editedIndex > -1) {
        //console.log("on slab change: ", editedIndex, payload);
        Object.assign(this.slabs[editedIndex], { ...payload });
        this.$emit("input", [...this.slabs]);
      }
    },
    onRemove(payload) {
      this.$emit("input", [...this.slabs.filter((s) => s.id != payload.id)]);
    },
  },

  apollo: {
    extraTypes: {
      query: ALL_EXTRA_SERVICE_TYPES_SEARCH_QUERY,
    },
  },
};
</script>

<style>
.short-input {
  width: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/templates/builder/TemplateSlabs.vue